import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { UtilService } from '../services/utils/util.service';

@Directive({
  selector: '[cmOnlyNumberDecimals]',
})
export class OnlyNumberDecimalsDirective implements AfterViewInit {
  @Input() onlyIntegers = false;
  constructor(private _el: ElementRef) { }

  ngAfterViewInit(): void {
    const input = this._el.nativeElement.getElementsByTagName('input')[0];

    // removes the dot in case there is no decimals added
    const sanitizeValue = (evt) => {
      const initialValue = input.value;
      const hasDecimal = UtilService.hasDecimal(initialValue);
      input.value = hasDecimal ? initialValue : initialValue ? Math.ceil(initialValue) : null;
      if (initialValue !== input.value) {
        evt.stopPropagation();
      }
    };

    // allows numbers and dots for decimals while typing
    input.addEventListener('input', (evt) => {
      const initialValue = input.value;
      input.value = this.onlyIntegers ? initialValue.replace(/[^0-9]*/g, '') : initialValue.replace(/[^0-9.]*/g, '');
      if (initialValue !== input.value) {
        evt.stopPropagation();
      }
    });

    input.addEventListener('blur', (evt) => sanitizeValue(evt));
    input.addEventListener('keypress', (evt) => {
      evt.key === 'Enter' && sanitizeValue(evt);
    });
  }
}
